<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

import SponsorshipOverviewContent from '@/components/SponsorhipOverview/SponsorshipOverviewContent.vue'
import SponsorshipHeading from '@/components/SponsorhipOverview/SponsorshipOverviewHeading.vue'
import {
  fetchSponsorshipOverviewStore,
  useOverviewData,
  useSponsorshipOverviewSeo
} from '@/services/sponsorshipService'
import {isSponsorshipFortalezaPresent} from "@/services/navigationService";
import { getCookie } from '@/utils/utils';

const data = ref<any>()
const isPublished = isSponsorshipFortalezaPresent()

useSponsorshipOverviewSeo()

const country = computed(() => {
  return getCookie('country') || ''
})

const sponsorshipSections = computed(() => {
  const sections = data.value?.sponsorships_section ?? []
  const visibleSections = isPublished ? sections : sections.slice(0, 1)

  return country.value === 'BR' ? visibleSections.slice(0, -1) : visibleSections
})

onMounted(async () => {
  await fetchSponsorshipOverviewStore()
  data.value = useOverviewData().value
})
</script>
<template>
  <SponsorshipHeading
    :title="data?.hero_section?.title"
    :subTitle="data?.hero_section?.subtitle"
    :logo="data?.sponsorship_hero?.sponsorlogo"
    :backgroundLogo="data?.hero_section?.image"
  ></SponsorshipHeading>
  <SponsorshipOverviewContent
    v-for="(insightprosection, index) in sponsorshipSections"
    :key="index"
    :title="insightprosection?.fields?.title"
    :content="insightprosection?.fields?.content"
    :image="insightprosection?.fields?.image"
    :button="{
      title: insightprosection?.fields?.button_title,
      href: insightprosection?.fields?.button_url
    }"
    :align="insightprosection?.fields?.orientation"
    :background-color="insightprosection.fields?.background_color"
  ></SponsorshipOverviewContent>
</template>
